cafm.reports = {
    isReportRunner: false,
    init: function (e) {
        cafm.setCurrentModule(cafm.enums.CAFMModuleEnum.Reports);
        cafm.nav.router = new cafm.router.Router({
            pathName: window.location.pathname,
            routes: cafm.reports.nav.routes,
            processOnInit: true,
            cache: true,
            'default': 'ReportsBrowse',
            routeKey: e.route ? e.route.routeKey : null,
            routeArgs: e.route ? e.route.routeArgs : null
        });
    },
    nav: {
        routes: {
            ReportsBrowse: {
                path: 'browse',
                handler: function () {

                    cafm.views.main({
                        url: cafm.url.get('ReportsExplorer/ReportBrowser')
                    });
                },
                documentTitle: "Reports"
            },
            ReportRunners: {
                path: 'reportrunners',
                handler: function () {
                    cafm.views.main({
                        url: cafm.url.get('ReportsExplorer/ReportRunners')
                    });
                    $("#leftCol").hide();//Or. Refactor and provide seperate script for RR!
                },
                documentTitle: "Reports"
            },
            ReportsBrowse2: {
                path: 'browse/{groupId}',
                noCache: true,
                handler: function (e) {

                    cafm.views.main({
                        url: cafm.url.get('ReportsExplorer/ReportBrowser/{0}', e.args.groupId)
                    });
                },
                documentTitle: "Reports"
            },
            ReportsView: {
                path: 'report/{id}',
                handler: function (e) {
                    cafm.views.main({
                        url: cafm.url.get('ReportsExplorer/ViewReport/' + e.args.id),
                        onLoad: cafm.reports.reportLoaded
                    });
                },
                documentTitle: "Reports"
            },
            NewReportRunner: {
                path: 'newreporrunner',
                handler: function (e) {
                    let crit = cafm.reports.getNewReportRunnerCriteria();
                    if (crit) {
                        cafm.views.main({
                            url: cafm.url.get('ReportsExplorer/NewReportRunner'),
                            values: crit
                        });
                    } else
                    {
                        cafm.nav.router.navigate(cafm.enums.Navigatable.ReportsBrowse);
                    }
                },
                documentTitle: "Reports"
            },
            EditReportRunner: {
                path: 'editreportrunner/{id}',
                handler: function (e) {
                    cafm.views.main({
                        url: cafm.url.get('ReportsExplorer/EditReportRunner/' + e.args.id)
                    });
                },
                documentTitle: "Reports"
            }
        },
        getEditLink: function (id) {

            return cafm.url.get('ReportsExplorer#editreportrunner/{0}', id);
        }
    },
    moduleGroupSelected: function (e) {

        var id = $(e.currentTarget).data('id');

        if (id) {
            window.location.hash = 'browse/{0}'.format(id);
        }
    },
    reportMouseOver: function (e) {

        var text = $(e.currentTarget);
        var item = text.parents('.reportItem:first');
        var id = item.data('key');
        var reportPreview = $('#reportPreview');

        if (id) {

            cafm.reports.previewTimeout = setTimeout(function () {
                if (!reportPreview.length) {
                    $('<img/>', {
                        src: cafm.url.api('Report/GetReportPreviewImage/' + id),
                        id: 'reportPreview',
                        'class': 'reportPreview'
                    }).appendTo(item);
                }
                else {
                    reportPreview.attr('src', cafm.url.api('Report/GetReportPreviewImage/' + id)).appendTo(item).show();
                }
            }, 0);
        }
    },
    reportMouseOut: function (e) {

        clearTimeout(cafm.reports.previewTimeout);
        $('#reportPreview').hide();
    },
    reportsBrowserTreeSelected: function (e) {

        switch (e.type) {

            case cafm.enums.TreeViewItemType.Category:

                if (e.item.parent().hasClass('contentBlockTree')) return;
                var toCollapse = $('> [data-expanded]', e.item.parent());
                e.tree.collapse(toCollapse);
                e.tree.expand(e.item);
                break;

            case cafm.enums.TreeViewItemType.Item:

                var reportId = e.item.data('key');

                cafm.nav.router.navigate(cafm.enums.Navigatable.ReportsView, {
                    id: reportId
                });

                break;
        }
    },
    reportsTreeSelected: function (e) {

        switch (e.type) {

            case cafm.enums.TreeViewItemType.FormCategory:

                cafm.reports.switchFormPanel(e);
                break;

            case cafm.enums.TreeViewItemType.Item:

                var isParam = $(e.event.target).closest('.tvParamVal,.tvParam').length > 0;

                if (isParam) {

                    e.item = e.item.closest('.tvItem[data-itemtype={0}]'.format(cafm.enums.TreeViewItemType.FormCategory));
                    cafm.reports.switchFormPanel(e);
                }

                break;
        }
    },
    reportLoaded: function (e) {

        cafm.reports.isReportRunner = false;

        cafm.forms.placeMainFormToolbar();

        $('#' + cafm.res.consts.ElementId_FormWidget).data('kendoTabStrip').select(0);

        cafm.reports.params.init();

        var report = cafm.views.getMainFormViewModel();

        cafm.nav.router.addRouteToHistory({
            itemKey: report.ID,
            itemTitle: report.Title,
            itemDetail: report.Description,
            itemType: cafm.enums.HistoryItemType.Report
        });
    },
    switchFormPanel: function (e) {

        e.tree.expand(e.item);
        $('#{0} .k-tabstrip-items [data-key="{1}"]'.format(cafm.res.consts.ElementId_FormWidget, e.item.data('key'))).click();
    },
    generateReportToolbar: {

        generate: function () {
            var viewModel = cafm.views.getMainFormViewModel(), actionViewModel = cafm.views.getActionWindowViewModel();
            cafm.cache.set('ReportFormat', actionViewModel.get('Format'));
            var repCrit = cafm.reports.getReportCriteria(viewModel);

            //Add Time Zone Parameter
            let tzParamData = cafm.reports.params.timeZone.getSelectedTimeZoneValue();
            repCrit.ParameterValues.push(tzParamData);

            delete repCrit.ParameterValuesWithText;
            cafm.actions.execute({
                url: cafm.url.api('Report/GenerateReportEmail'),
                elementId: cafm.res.consts.ElementId_ActionForm,
                preventValidationMessage: true,
                loaderSelector: '#{0}, .winButtons [data-key="Generate"]'.format(cafm.res.consts.ElementId_ActionForm),
                values: {
                    Criteria: repCrit,
                    Message: cafm.reports.getMessageData(viewModel.get('Title'), actionViewModel.get('ReportToEmail')),
                    Format: cafm.util.getItemValue(actionViewModel.get('Format'))
                },
                statusCodeFuncs: {
                    200: function (res) {

                        $('#generateReportForm .cFieldSet').hide();
                        $('#generateReportForm').showMessage({
                            Title: cafm.res.str.MessageReportGenerating,
                            Type: cafm.enums.MessageType.Success
                        });
                    }
                }
            });
        },
        cancel: function () {

            cafm.toolbar.standardActionToolbar.cancel();
        }
    },
    reportRunnerToolbar: {
        save: function (e) {
            var data = cafm.views.getMainFormViewModel(), element = cafm.views.getActionForm();
            var recurrData = cafm.views.getMainForm().find(".recurrenceForm");
            data.RecurrencePattern = recurrData.getViewModel();
            var saveAction = {
                url: cafm.url.api('ReportRunner/Update'),
                values: data,
                element: element,
                loaderTarget: '.actionPanel,.winButtons [data-key=Save]',
                beforeExecute: cafm.reports.handlers.beforeSaveReportRunner,
                statusCodeFuncs: {
                    200: function (r) {
                        cafm.reports.showReportRunnersList();
                    }
                }
            };

            var dateParamsValid = cafm.reports.reportRunnerDateParamsAreValid(data.Parameters);
            if (!dateParamsValid) {
                cafm.util.yesNoDialogue({
                    message: cafm.res.str.MessageReporRunnerContainsDateParametersWithNoValue,
                    messageType: cafm.enums.MessageType.Warning,
                    yesHandler: function () {
                        cafm.actions.execute(saveAction);
                    }
                });
            } else
            {
                cafm.actions.execute(saveAction);
            }
        },
        cancel: function () {
            cafm.reports.showReportRunnersList();
        },
        DeleteReportRunner: function (e) {
            let rr = cafm.views.getMainFormViewModel();
            cafm.util.yesNoDialogue({
                message: cafm.res.str.MessageDeleteReportRunner,
                yesHandler: function () {
                    cafm.actions.execute({
                        url: cafm.url.api('ReportRunner/Delete'),
                        values: cafm.util.idData(rr.ID),
                        loaderSelector: '#mainContentPane',
                        preventValidate: true,
                        statusCodeFuncs: {
                            200: function (r) {
                                cafm.reports.showReportRunnersList();
                            }
                        }
                    });
                }
            });
        },
        export: function (e)
        {
            let expFormat = e.button['data-value'];
            var exportReq = {
                Format: cafm.enums.ExportFormatData[expFormat],
                Service: "ReportRunner",
                ListMemberName: "GetList",
                InputParam: null,
                ExcludeColumns: ["FileName", "FileLocation", "FileOutputOptionDescription", "ConfirmationPrompt", "DataCaptureRequest"]
            };
            cafm.actions.execute({
                download: true,
                url: cafm.url.api(cafm.res.consts.ApiPath_ExportExecute),
                values: exportReq
            });
        }
    },
    recipientsToolbar: {
        add: function (e) {
            cafm.views.openActionWindow({
                url: cafm.url.get('reportsexplorer/NewReportRunnerRecipient'),
                viewModel: {
                    ID: cafm.guid.newGuid(),
                    _isNew: true
                }
            });
        },
        edit: function (e) {
            var editBtn = $(e.target);
            var editTarget = editBtn.data('editTarget');
            var lv = editBtn.getLvFromTb();
            var id = editTarget.data('id');
            var vm = cafm.util.clone(lv.element.getListViewDataItem(id, 'ID'));
            cafm.views.openActionWindow({
                url: cafm.url.get('reportsexplorer/EditReportRunnerRecipient/{0}'.format(id)),
                viewModel:vm
            });
            
        },
        remove: function (e)
        {
            var remBtn = $(e.target);
            var id = remBtn.getListSelectedDataItems()[0].ID

            if (!id) {
                $(remBtn).showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.MessageNoRecipientSelected });
                return;
            }
            var vm = cafm.views.getMainFormViewModel();
            if (vm.Recipients) {
                cafm.util.removeWhere(vm.Recipients.Items, function (r) {
                    return r.ID == id;
                });
                cafm.reports.refreshRecipientsData();
            }
        },
        save: function () {

            let recipData = cafm.views.getActionWindowViewModel();
            var vm = cafm.views.getMainForm().getViewModel();
            vm.Recipients = vm.Recipients || [];

            if (recipData._isNew)
            {
                vm.Recipients.Items.push(recipData);
                recipData._isNew = false;
            } else
            {
                let target = cafm.util.find(vm.Recipients.Items, function (p) {
                    return p.ID == recipData.ID;
                });
                target.Name = recipData.Name;
                target.EmailAddress = recipData.EmailAddress;
                target.EmailSubject = recipData.EmailSubject;
                target.EmailBody = recipData.Body;
                target.IsNotificationOnly = recipData.IsNotificationOnly;
            }
            
            cafm.reports.refreshRecipientsData();
            cafm.views.closeActionWindow();
        },
        cancel: function (e) {
            cafm.toolbar.standardActionToolbar.cancel(e);

        }
    },
    getReportCriteria: function (viewModel) {

        var criteria = {
            ID: viewModel.get('ID'),
            Format: cafm.enums.ExportFormatData.Pdf,
            ParameterValues: [],
            ParameterValuesWithText: []
        };

        for (var key in viewModel) {

            if (!isFunc(viewModel[key]) && key.indexOf(cafm.res.consts.FieldName_ReportParamPrefix) == 0) {
                var data = viewModel.get(key);

                if (key == cafm.res.consts.FieldName_ReportFormatParam)
                {
                    criteria.Format = data;
                    continue;
                }

                var dataAndTxt = viewModel.get(key);
                var fieldName = key.replace(cafm.res.consts.FieldName_ReportParamPrefix, '@');
                var param = cafm.util.find(viewModel.Parameters.Items, function (p) {
                    return p.ParameterName == fieldName;
                });

                if (data) {

                    if (isFunc(data.toJSON)) {
                        data = data.toJSON();
                        dataAndTxt = data;
                    }

                    if (!isArray(data)) {

                        if (data.value && data.text) {

                            // handle kendo dropdown selected items
                            data = data.value;
                            dataAndTxt = data;
                        }

                        data = [data];
                        dataAndTxt = [dataAndTxt];
                    }
                    else if (data.length && isDefined(data[0].value)) {

                        data = cafm.util.selectValue(data, 'value');
                        dataAndTxt = dataAndTxt;
                    }

                    if (data.length) {
                        criteria.ParameterValues.push({
                            ParameterID: param.get('ID'),
                            Values: data
                        });

                        criteria.ParameterValuesWithText.push({
                            ParameterID: param.get('ID'),
                            Values: dataAndTxt
                        });
                    }
                }
            }
        }

        return criteria;
    },
    getNewReportRunnerCriteria: function () {

        var vm = cafm.views.getMainFormViewModel();
        if (vm == null) return;

        var repCrit = cafm.reports.getReportCriteria(vm).ParameterValuesWithText;

        var parmValues = cafm.util.transformArray(repCrit, function (item) {
            return {
                ParameterID: item.ParameterID,
                ValuesComplex: cafm.util.transformArray(item.Values, function (vcItem) {
                    return {
                        RawValue: vcItem.value ? vcItem.value : vcItem,
                        UIValue: vcItem.text ? vcItem.text : vcItem
                    }
                })
            };
        });

        //Add Time Zone Parameter
        let tzParamData = cafm.reports.params.timeZone.getSelectedTimeZoneValue();
        parmValues.push(tzParamData);

        var newRepRunnerCrit = {
            ID: vm.ID,
            ParameterValues: parmValues
        };
        return newRepRunnerCrit;
    },
    bindReportRunnerRecipients() {
        var vm = cafm.views.getMainForm().getViewModel();
        return isNullOrUndefined(vm.Recipients) ? [] : vm.Recipients;
    },
    getMessageData: function (title, toAddress) {

        return {
            Subject: title,
            Recipients: [{
                Address: toAddress,
                Type: cafm.enums.RecipientTypeData.To
            }]
        };
    },
    getRecipientsData: function () {
        var vm = cafm.views.getMainForm().getViewModel();
        if (vm) {
            vm.Recipients = vm.Recipients || [];
            return vm.Recipients.Items;
        } else {
            return [];
        }

    },
    refreshRecipientsData: function () {
        $("#recipientsLv").refreshListDS();

    },
    showReportRunnersList: function () {
        cafm.nav.router.navigate(cafm.enums.Navigatable.ReportRunners);
    },
    onReportRunnerLoaded: function () {

        cafm.reports.isReportRunner = true;
        cafm.handlers.set('cafm.forms.afterFormTabChanged', function (contentElement) {
            // check for removable items
            cafm.forms.checkForRemovables();
        });
        $('#recipientsLv').refreshListDS();
        setTimeout(function () {
            var paramsFromSource = cafm.reports.params.populateReportRunnerParameters();
            cafm.reports.params.init();
            //Dropdowns and MultiSelects are set to Init Value from cafm.forms. Hence need to set value here
            cafm.views.getMainForm().getDropdowns().forEach(dd => {
                let paramId = dd.element.attr("data-paramid");
                if (paramId)
                {

                    let paramContainer = paramsFromSource[paramId];
                    if (paramContainer) {
                        let paramObj = paramsFromSource[paramId]._param;
                        let paramValue = paramsFromSource[paramId];
                        let isIimplicitDateParam = paramObj.ParameterType == 2 || paramObj.ParameterType == 15 || paramObj.ParameterType == 16;
                        if (paramValue) {
                            if (isIimplicitDateParam) {
                                dd.value(paramObj.ParameterValueType);
                                dd.element.trigger("change");
                            } else {
                                if (paramValue.Value && paramValue.Value[0]) {
                                    dd.value(paramValue.Value[0].value);
                                }
                            }
                        }
                    }
                }
            });

            cafm.views.getMainForm().getMultiSelects().forEach(ms => {
                let paramId = ms.element.attr("data-paramid");
                if (paramId) {
                    let values = cafm.util.transformArray(paramsFromSource[paramId].Value, function (vc)
                    {
                        return vc.value;
                    });
                    if (values) {
                        ms.value(values);
                        ms.wrapper.setMultiSelectText();
                    }
                }
            });

            $("select[id*='{0}']".format(cafm.res.consts.FieldName_ImplicitDateTypePartSuffix)).each((i,dd) => { cafm.reports.params.showHideImplicitDateParameterParts(dd) });

            //cafm.views.getMainForm().rebindViewModel(); //Either Checkboxes Or Dropdowns work!!
        }, 200);
    },
    generateReportLoad: function (element) {
        cafm.reports.isReportRunner = false;
        var vm = cafm.views.getActionWindowViewModel(),
            cacheFormat = cafm.cache.get('ReportFormat');

        if (cacheFormat && cacheFormat != vm.Format && cafm.views.getMainFormViewModel().CrystalReportExists) {
            vm.set('Format', cacheFormat);
        }
    },
    getReportTimeZoneName: function (id) {
        var userZones = cafm.cache.get(cafm.res.consts.CacheKey_UserTimeZones);
        var selectedZone = cafm.util.find(userZones, z => {
            return z.ID == id;
        })
        return selectedZone.Name;
    },
    params: {
        init: function () {

            var mainForm = cafm.views.getMainForm();
            var treeView = null;
            if (cafm.reports.isReportRunner === false) {
                treeView = nav.getKendoNavTree();
                treeView.element.on('click', '.tvParamVal', function (ev) {

                    var item = $(ev.currentTarget);
                    var handler = item.data('paramHandler')

                    if (handler && isFunc(handler.removeParam)) {
                        handler.removeParam(ev);
                    }
                });
            }

            cafm.reports.params.date.setup({
                mainForm: mainForm,
                treeView: treeView
            });
            cafm.reports.params.lookup.setup({
                mainForm: mainForm,
                treeView: treeView
            });
            cafm.reports.params.dropdown.setup({
                mainForm: mainForm,
                treeView: treeView
            });
            cafm.reports.params.multiSelect.setup({
                mainForm: mainForm,
                treeView: treeView
            });
            cafm.reports.params.checkbox.setup({
                mainForm: mainForm,
                treeView: treeView
            });
            cafm.reports.params.textbox.setup({
                mainForm: mainForm,
                treeView: treeView
            });
            cafm.reports.params.timeZone.setup({
                mainForm: mainForm,
                treeView: treeView
            });
        },
        addParam: function (e) {
            if (!e.treeView) { //LHS Tree View is present on on ReportViewModel not on ReportRunnerViewModel
                return;
            }
            cafm.util.callFunctionAsync({
                func: function () {
                    var paramTreeItem = $('[data-key="{0}"]'.format(e.fieldName), e.treeView.element);
                    var existingParamVal = $('.tvParamVal', paramTreeItem);
                    if (existingParamVal.length) {

                        existingParamVal.each(function (i, el) {

                            e.treeView.remove(el);
                        });
                    }

                    paramTreeItem.show();

                    if (!isArray(e.fieldDescription) && e.fieldDescription) {

                        var newItem = e.treeView.append({
                            text: e.fieldDescription,
                            imageUrl: cafm.url.get('Content/Themes/Default/icons/grey/1061-remove-16.png')
                        }, paramTreeItem);
                        newItem.addClass('tvParamVal').attr('data-itemtype', cafm.enums.TreeViewItemType.FilterValue);
                        newItem.attr('title', e.fieldDescription);
                        newItem.data('relatedControl', e.fieldControl);
                        newItem.data('text', e.fieldDescription);
                        newItem.data('paramHandler', e.handler);
                        return newItem;
                    }
                    else if (isArray(e.fieldDescription) && e.fieldDescription.length) {

                        var newItems = [];
                        e.fieldDescription.forEach(function (fd) {

                            var newItem = e.treeView.append({
                                text: fd,
                                imageUrl: cafm.url.get('Content/Themes/Default/icons/grey/1061-remove-16.png')
                            }, paramTreeItem);
                            newItem.addClass('tvParamVal').attr('data-itemtype', cafm.enums.TreeViewItemType.FilterValue);
                            newItem.attr('title', fd);
                            newItem.data('relatedControl', e.fieldControl);
                            newItem.data('text', fd);
                            newItem.data('paramHandler', e.handler);
                            newItems.push(newItem);
                        });
                        return newItems;
                    }
                    else {

                        paramTreeItem.hide();
                    }
                },
                timeout: 250
            })
        },
        removeParam: function (e, preventVmSet) {

            var item = $(e.target);
            if (!item.hasClass('tvParamVal')) {
                item = item.parents('.tvParamVal:first');
            }
            var fieldName = item.parents('.tvItem:first').data('key');
            var viewModel = cafm.views.getMainFormViewModel();

            if (isUndefined(preventVmSet) || !preventVmSet) {

                viewModel.set(fieldName, null);
            }

            var treeView = nav.getKendoNavTree();
            var relatedControl = item.data('relatedControl');
            var paramItem = item.parents('.tvParam:first');

            treeView.remove(item);

            if (!$('> .k-group', paramItem).length) {
                paramItem.hide();
            }

            return relatedControl;
        },
        date: {

            setup: function (e) {

                e.mainForm.getDatePickers().forEach(function (datePicker) {

                    datePicker.bind('change', function (ev) {

                        cafm.reports.params.date.addParam({

                            datePicker: datePicker,
                            treeView: e.treeView
                        });

                        // check for a group key
                        if (!isNullOrUndefined(datePicker.element.data('key'))) {

                            cafm.reports.params.date.onGroupedFieldChange({

                                datePicker: datePicker
                            });
                        }
                    });
                });
            },
            addParam: function (e) {

                var fieldName = e.datePicker.element.attr('name');
                var value = e.datePicker.value();
                var fieldDescription = value ? kendo.toString(value, 'd') : null;

                if (value) {
                    var paramItem = cafm.reports.params.addParam({
                        treeView: e.treeView,
                        fieldControl: e.datePicker,
                        fieldName: fieldName,
                        fieldDescription: fieldDescription,
                        fieldValue: value,
                        handler: cafm.reports.params.date
                    });
                } else
                {
                    var vm = cafm.views.getMainFormViewModel();
                    vm.set(fieldName, null);
                }

                if (!fieldDescription) {

                    e.datePicker.value('');
                }
            },
            removeParam: function (ev) {

                var datePicker = cafm.reports.params.removeParam(ev);
                datePicker.value('');

                cafm.reports.params.date.onGroupedFieldChange({

                    datePicker: datePicker
                });
            },
            onGroupedFieldChange: function (e) {

                var groupContainer = $(e.datePicker.element).parents('.fieldGroup:first');
                var groupKey = e.datePicker.element.data('key');
                var groupDateFields = $('.cfControl[data-key][data-fieldtype="{0}"]'.format(e.datePicker.element.data('fieldtype')), groupContainer);
                var currentGroupDateFields = groupDateFields.filter('[data-key="{0}"]'.format(groupKey));
                var otherGroupDateFields = groupDateFields.not('[data-key="{0}"]'.format(groupKey));
                var val = e.datePicker.value();

                if (!val) {

                    // check current group fields for value
                    currentGroupDateFields.each(function (i, el) {

                        var dp = $(el).data('kendoDatePicker');
                        if (!val) val = dp.value();
                    });
                }

                otherGroupDateFields.each(function (i, el) {

                    var dp = $(el).data('kendoDatePicker');
                    dp.enable(!val);

                    if (val) {

                        dp.value('');
                    }
                });
            }
        },
        lookup: {

            setup: function (e) {

                e.mainForm.getLookups().forEach(function (lookup) {

                    if (!lookup.data('showlist')) {
                        var singleLookupVal = $('input[data-role="lookupValue"]', lookup);
                        singleLookupVal.bind('change', function (ev) {

                            cafm.reports.params.lookup.addParam({

                                lookup: lookup,
                                treeView: e.treeView
                            });
                        });
                    }
                    else {

                        var list = $('.simpleList', lookup);
                        list.bind('change', function (ev) {

                            cafm.reports.params.lookup.addParam({

                                lookup: lookup,
                                treeView: e.treeView
                            });
                        });
                    }
                });
            },
            addParam: function (e) {

                var fieldName;
                var fieldDescription;
                var fieldValue;

                if (!e.lookup.data('showlist')) {

                    var textBox = $('input[data-role="lookupText"]', e.lookup);
                    fieldName = textBox.attr('name');
                    fieldDescription = textBox.textVal();
                }
                else {

                    var list = $('.simpleList', e.lookup);
                    fieldName = list.data('name');
                    var items = JSON.safeParse(list.attr('data-items'));
                    if (items) {

                        fieldDescription = cafm.util.selectValue(items, 'text');
                        fieldValue = cafm.util.selectValue(items, 'value');
                    }
                }

                var paramItems = cafm.reports.params.addParam({

                    treeView: e.treeView,
                    fieldControl: e.lookup,
                    fieldName: fieldName,
                    fieldDescription: fieldDescription,
                    fieldValue: fieldValue,
                    handler: cafm.reports.params.lookup
                });
            },
            removeParam: function (ev) {

                var item = $(ev.currentTarget);
                var itemText = item.data('text');
                var lookup = item.data('relatedControl');
                cafm.reports.params.removeParam(ev, cafm.util.isTrue(lookup.data('multi')));

                $('.simpleListItem', lookup).each(function (i, el) {

                    var item = $(el);
                    if (item.text().trim() == itemText.trim()) {
                        $(item).click();
                    }
                });
            }
        },
        dropdown: {

            setup: function (e) {

                e.mainForm.getDropdowns().forEach(function (dropdown) {

                    // if the dropdowns already have a value then trigger the change event to ensure the default values are pushed onto the view model
                    if (dropdown.value()) {

                        dropdown.trigger('change');
                    }

                    // must be after the change triggers as we don't want the default values to appear as selected params in the param tree
                    dropdown.bind('change', function (ev) {

                        cafm.reports.params.dropdown.addParam({

                            dropdown: dropdown,
                            treeView: e.treeView
                        });
                    });
                });
            },
            addParam: function (e) {

                //var fieldName = e.dropdown.element.attr('name');
                var fieldName = cafm.reports.params.getFieldName(e.dropdown.element.attr('name'));
                var fieldDescription = e.dropdown.text();
                var defaultVal = e.dropdown.element.data('default');
                var fieldValue = e.dropdown.element.data('value');

                var vm = cafm.views.getMainFormViewModel();
                if (vm.get(fieldName) && vm.get(fieldName).value) {

                    vm.set(fieldName, vm.get(fieldName).value);
                }

                if (!defaultVal || vm.get(fieldName) != defaultVal) {

                    var paramItem = cafm.reports.params.addParam({

                        treeView: e.treeView,
                        fieldControl: e.dropdown,
                        fieldName: fieldName,
                        fieldDescription: fieldDescription,
                        fieldValue: fieldValue,
                        handler: cafm.reports.params.dropdown
                    });
                }
                else {

                    var treeParam = $('.tvParam[data-key="{0}"]'.format(fieldName));

                    $('.tvParamVal', treeParam).each(function (i, el) {

                        cafm.reports.params.removeParam({
                            target: el
                        });
                    });
                }
            },
            removeParam: function (ev) {

                var control = cafm.reports.params.removeParam(ev);
                control.value('');
            }
        },
        multiSelect: {

            setup: function (e) {

                e.mainForm.getMultiSelects().forEach(function (ms) {

                    var defaultVal = ms.element.data('default');
                    var val = ms.value();

                    // if the multi selects already have a value then trigger the change event to ensure the default values are pushed onto the view model
                    if (val) {
                        ms.trigger('change');
                    }

                    if (val && val[0] == defaultVal) {

                        ms.value('');
                        ms.wrapper.setMultiSelectText('');
                    }

                    // must be after the change triggers as we don't want the default values to appear as selected params in the param tree
                    ms.bind('change', function (ev) {
                        cafm.reports.params.multiSelect.addParam({

                            multiSelect: ms,
                            treeView: e.treeView
                        });
                    });
                });
            },
            addParam: function (e) {
                var fieldName = cafm.reports.params.getFieldName(e.multiSelect.element.attr('name'));
                var defaultVal = e.multiSelect.element.data('default');
                var values = e.multiSelect.value();
                var fieldDescription = [];
                var dataItems = e.multiSelect.dataItems();
                var vm = cafm.views.getMainFormViewModel();

                if (!defaultVal || !cafm.util.exists(dataItems, function (di) { return parseInt(di.value) == defaultVal; })) {

                    values.forEach(function (item) {

                        var dataItem = cafm.util.find(dataItems, function (i) {

                            return i.value == item;
                        });

                        fieldDescription.push(dataItem.text);
                    });

                    // ensure the view model is updated for some reason multiselect isn't updating the vm here.
                    vm.set(fieldName, dataItems);

                    var paramItem = cafm.reports.params.addParam({

                        treeView: e.treeView,
                        fieldControl: e.multiSelect,
                        fieldName: fieldName,
                        fieldDescription: fieldDescription,
                        handler: cafm.reports.params.multiSelect
                    });
                }
                else {

                    var treeParam = $('.tvParam[data-key="{0}"]'.format(fieldName));

                    $('.tvParamVal', treeParam).each(function (i, el) {

                        cafm.reports.params.removeParam({
                            target: el
                        });
                    });

                    vm.set(fieldName, null);
                }
            },
            removeParam: function (ev) {

                var control = cafm.reports.params.removeParam(ev, true);
                var itemText = $(ev.currentTarget).text();

                $('.k-button', control.wrapper).each(function (i, el) {

                    var textItem = $('span:first', el);
                    if (textItem.text().trim() == itemText.trim()) {
                        $('.k-select', el).click();
                    }
                });
            }
        },
        checkbox: {

            setup: function (e) {

                e.mainForm.getCheckboxes().forEach(function (checkbox) {

                    $('.cfControl', checkbox).bind('change', function (ev) {

                        cafm.reports.params.checkbox.addParam({

                            checkbox: checkbox,
                            treeView: e.treeView
                        });
                    });
                });
            },
            addParam: function (e) {

                var fieldName = $('.cfControl', e.checkbox).attr('name');
                var fieldDescription = e.checkbox.isChecked() ? cafm.res.str.TextYes : cafm.res.str.TextNo;

                var paramItem = cafm.reports.params.addParam({

                    treeView: e.treeView,
                    fieldControl: e.checkbox,
                    fieldName: fieldName,
                    fieldDescription: fieldDescription,
                    handler: cafm.reports.params.checkbox
                });
            },
            removeParam: function (ev) {

                var control = cafm.reports.params.removeParam(ev);
                control.setChecked(false, true);
            }
        },
        textbox: {

            setup: function (e) {

                e.mainForm.getTextboxes().forEach(function (textbox) {

                    var tboxes = textbox.hasClass('cfTextInput') ? textbox : $('input', textbox).not('.k-formatted-value');
                    tboxes.bind('change', function (ev) {

                        cafm.reports.params.textbox.addParam({

                            textbox: $(ev.target),
                            treeView: e.treeView
                        });
                    });
                });
            },
            addParam: function (e) {

                var fieldName = e.textbox.attr('name');
                var fieldDescription = e.textbox.textVal();

                var paramItem = cafm.reports.params.addParam({

                    treeView: e.treeView,
                    fieldControl: e.textbox,
                    fieldName: fieldName,
                    fieldDescription: fieldDescription,
                    handler: cafm.reports.params.textbox
                });
            },
            removeParam: function (ev) {

                var control = cafm.reports.params.removeParam(ev);
                control.val('');
            }
        },
        timeZone: {
            setup: function (e) {

                let tzParamSelect = e.mainForm.find("select[data-paramtype='SessionTimeZone']");
                $(tzParamSelect).bind('change', function (e) {
                    let dtPickers = tzParamSelect.closest('.reportForm').getDatePickers();
                    if (dtPickers.length > 0) {
                        let tz = cafm.reports.getReportTimeZoneName(e.target.value);
                        dtPickers.forEach(function (dtp) {

                            dtp.element.data('currentTimeZone', tz);
                            dtp.element.trigger('change');
                        });
                    }
                });
            },
            getSelectedTimeZoneValue: function () {
                let tzDropdown = cafm.views.getMainForm().find("select[data-paramtype='SessionTimeZone']");
                let tzParamId = tzDropdown.data('paramid');
                let tzValue = tzDropdown.val();
                let tzText = tzDropdown.text();
                let tzData = {
                    ParameterID: tzParamId,
                    Values: [tzValue],
                    ValuesComplex: [
                        {
                            RawValue: tzValue,
                            UIValue: tzText
                        }
                    ]
                };
                return tzData;
            }
        },
        populateReportRunnerParameters() {
            var vm = cafm.views.getMainFormViewModel(), paramDict = {};
            vm.ReportRunnerParameters.forEach(function (p) {

                var values, value, description;
                if (cafm.util.hasItem(p.ParameterValues.ValuesComplex)) {
                    values = cafm.util.transformArray(p.ParameterValues.ValuesComplex, function (vc) {
                        return {
                            text: vc.UIValue,
                            value: vc.RawValue
                        };
                    });
                    description = cafm.util.selectValue(p.ParameterValues.ValuesComplex, 'UIValue').join(', ');
                    value = cafm.util.selectValue(p.ParameterValues.ValuesComplex, 'RawValue');
                };


                let isImplictDate = (p.ParameterType == cafm.enums.ParameterTypeData.Date || p.ParameterType == cafm.enums.ParameterTypeData.DateTimeFrom || p.ParameterType == cafm.enums.ParameterTypeData.DateTimeTo);
                if (isImplictDate) {
                    //Add DatePart and Numeric Part parameters to Dictionary
                    let dropDownPart = '{0}{1}'.format(p.ReporParameterID, cafm.res.consts.FieldName_ImplicitDateTypePartSuffix);
                    let datePartKey = '{0}{1}'.format(p.ReporParameterID, cafm.res.consts.FieldName_ImplicitDateDatePartSuffix);
                    let numericPartKey = '{0}{1}'.format(p.ReporParameterID, cafm.res.consts.FieldName_ImplicitDateNumericPartSuffix);

                    paramDict[dropDownPart] = {
                        _param: p,
                        IsImplicitDateTypePart:true,
                        Value: p.ParameterValueType
                    };

                    paramDict[datePartKey] = {
                        _param: p,
                        IsImplicitDateDatePart: true
                    };

                    paramDict[numericPartKey] = {
                        IsImplicitDateNumericPart: true,
                        _param: p,
                    };

                    switch (p.ParameterValueType) {
                        case 6:
                        case 8:
                        case 11:
                            paramDict[numericPartKey].Value = values ? values[0].value : null;
                            break;
                        case 12://Specific Date
                            paramDict[datePartKey].Value = values ? values[0].text : null;
                            break;
                    }

                } else
                {
                    switch (p.ParameterType)
                    {
                        case 1://Boolean
                        case 7://String
                        case 14://Time Zone
                            paramDict[p.ReporParameterID] = {
                                _param: p,
                                Description: description,
                                Value: values
                            };
                            break;
                        default:
                            paramDict[p.ReporParameterID] = {
                                _param: p,
                                Description: description,
                                Value: values
                            };
                            break;
                    }
                }
            });

            vm.set({ Parameters: paramDict });
            return paramDict;
        },
        getFieldName: function (fieldName) {
            return cafm.reports.isReportRunner === true ? fieldName.replace("_", ".") : fieldName;
        },
        onImplicitDateParameterChanged: function (e)
        {
            let impDropDown = $(e.target);
            cafm.reports.params.showHideImplicitDateParameterParts(impDropDown)
            
        },
        showHideImplicitDateParameterParts: function (typeDropdown) {

            let dd = $(typeDropdown);
            let wrapper = dd.closest("#ImplicitDateWrapper");
            let selectedVal = Number(dd.val());
            let dateChildren = wrapper.find("div[class*=ImplicitDate]")
            let numericChild = wrapper.find("div[class*=ImplicitNumeric]")

            dateChildren.hide();
            numericChild.hide();

            switch (selectedVal) {
                case cafm.enums.ReportParameterValueTypeData.ImplicitDateMonthStartPlusMinusNMonths:
                case cafm.enums.ReportParameterValueTypeData.ImplicitMonthEndPlusMinusNMonths:
                case cafm.enums.ReportParameterValueTypeData.ImplicitDateTodayPlusMinusNDays:
                    numericChild.show();
                    break;
                case cafm.enums.ReportParameterValueTypeData.ImplicitDateSpecificDate:
                    let first = $(dateChildren[0]);
                    first.show();
                    break;
            }
        }
    },
    reportRunnerDateParamsAreValid: function (repParams) {
        var typeParts = cafm.util.where(repParams, p => p.IsImplicitDateTypePart);
        let invalid = typeParts.some(function (tp)
        {
            let typeVal = Number(isObj(tp.Value) ? tp.Value.value : tp.Value);
            switch (typeVal) {
                case cafm.enums.ReportParameterValueTypeData.ImplicitDateMonthStartPlusMinusNMonths:
                case cafm.enums.ReportParameterValueTypeData.ImplicitMonthEndPlusMinusNMonths:
                case cafm.enums.ReportParameterValueTypeData.ImplicitDateTodayPlusMinusNDays:
                    let numPart = cafm.util.where(repParams, rp => rp.IsImplicitDateNumericPart && rp._param.ID == tp._param.ID);
                    return numPart.length == 0 || numPart[0].Value == null;
                    break;
                case cafm.enums.ReportParameterValueTypeData.ImplicitDateSpecificDate:
                    let datePart = cafm.util.where(repParams, rp => rp.IsImplicitDateDatePart && rp._param.ID == tp._param.ID);
                    return datePart.length == 0 || datePart[0].Value == null;
                    break;
                case cafm.enums.ReportParameterValueTypeData.ImplicitDateToday:
                case cafm.enums.ReportParameterValueTypeData.ImplicitDateTomorrow:
                case cafm.enums.ReportParameterValueTypeData.ImplicitDateWeekStart:
                case cafm.enums.ReportParameterValueTypeData.ImplicitDateWeekEnd:
                case cafm.enums.ReportParameterValueTypeData.ImplicitDateMonthStart:
                case cafm.enums.ReportParameterValueTypeData.ImplicitDateMonthEnd:
                case cafm.enums.ReportParameterValueTypeData.ImplicitDateYearStart:
                case cafm.enums.ReportParameterValueTypeData.ImplicitDateYearEnd:
                    return false;
                    break;
                default:
                    return true; 
                    break;
            }
        });

        return invalid == false;

    },
    handlers: {
        reportRunnerTabSelected: function (e, afterTabChange) {
            cafm.forms.handlers.formTabChanged(e, afterTabChange);
            var item = $(e.item);
            var key = item.data('key');
            if (key === "ReportRunnerScheduleTab") {
                var vm = cafm.views.getMainForm().getViewModel();
                setTimeout(() => {
                    cafm.recurrence.handlers.prepareForm(vm.RecurrencePattern, cafm.reports.handlers.reportScheduleUpdated);
                }, 1000);
            }
        },
        reportScheduleUpdated: function (updatedSchedule) {
            alert("Report Runner Schedule Updated" + updatedSchedule);
        },
        browser: {
            back: function () {
                cafm.nav.router.navigate(cafm.enums.Navigatable.ReportsBrowse);
            }
        },
        beforeSaveReportRunner: function (args) {

            var vm = args.values;
            if (vm.Parameters) {

                for (var name in vm.Parameters) {

                    var p = vm.Parameters[name];

                    if (isObj(p) && p._param) {

                        var wp = cafm.util.find(vm.ReportRunnerParameters, function (wp) { return wp.ReporParameterID == p._param.ReporParameterID });

                        var value, valueComplex;

                        if (isArray(p.Value)) {
                            if (p.Value.length) {
                                value = cafm.util.transformArray(p.Value, function (v) { return v.value });
                                valueComplex = cafm.util.transformArray(p.Value, function (v) { return { RawValue: v.value, UIValue: v.text } });
                            }
                            else {
                                value = [];
                                valueComplex: []
                            }
                        }
                        else if (!isNullOrUndefined(p.Value) && isDate(p.Value)) {

                            value = [p.Value];
                            valueComplex = [{ RawValue: p.Value, UIValue: p.text }];
                        }
                        else if (!isNullOrUndefined(p.Value) && isObj(p.Value)) {

                            value = [cafm.util.getItemValue(p.Value)];
                            valueComplex = [{ RawValue: p.Value.value, UIValue: p.Value.text }];
                        }
                        else {

                            value = isNullOrUndefined(p.Value) ? [] : [p.Value];
                            valueComplex = [{ RawValue: p.Value, UIValue: p.Value }];
                        }

                        let isImplictDate = (wp.ParameterType == cafm.enums.ParameterTypeData.Date || wp.ParameterType == cafm.enums.ParameterTypeData.DateTimeFrom || wp.ParameterType == cafm.enums.ParameterTypeData.DateTimeTo);
                        if (isImplictDate)
                        {
                            if (p.IsImplicitDateTypePart && value.length > 0)
                            {
                                wp.ParameterValueType = value[0];
                            }
                            else if (p.IsImplicitDateDatePart && value.length > 0)
                            {
                                wp.ParameterValues.Values = value;
                                wp.ParameterValues.ValuesComplex = valueComplex;
                            } else if (p.IsImplicitDateNumericPart && value.length > 0)
                            {
                                wp.ParameterValues.Values = value;
                                wp.ParameterValues.ValuesComplex = valueComplex;
                            }
                        } else
                        {
                            wp.ParameterValues.Values = value;
                            wp.ParameterValues.ValuesComplex = valueComplex;
                        }
                    }
                }

                delete vm.Parameters;
            }
            else if (vm.ReportRunnerParameters) {

                vm.ReportRunnerParameters.forEach(function (wp) {

                    if (!wp.ParameterValues.Values) wp.ParameterValues.Values = [];
                });
            }
        },
        form: function (e) {

            var key = e.key || e.button['data-key'];

            switch (key) {

                case 'OpenGenerateForm':
                    var viewModel = cafm.views.getMainFormViewModel();
                    cafm.views.openActionWindow({
                        url: cafm.url.get('~/reportsexplorer/generatereport/' + viewModel.ID),
                        winOpts: {
                            title: cafm.res.str.TextGenerateReport,
                            minHeight: 240
                        },
                        onLoad: cafm.reports.generateReportLoad,
                        closeOnOverlayClick: true
                    })
                    break;
                case 'NavigateToReportSchedule':
                    var viewModel = cafm.views.getMainFormViewModel();
                    cafm.nav.router.navigate(cafm.enums.Navigatable.NewReportRunner, {
                        id: viewModel.ID
                    });
                    break;
                case 'PrintReport':

                    var viewModel = cafm.views.getMainFormViewModel();
                    var repCrit = cafm.reports.getReportCriteria(viewModel);

                    //Add Time Zone Parameter
                    let tzParamData = cafm.reports.params.timeZone.getSelectedTimeZoneValue();
                    let tzParamValue =
                    {
                        ParameterID: tzParamData.ParameterID,
                        Values: [tzParamData.ValuesComplex[0].RawValue]
                    };

                    repCrit.ParameterValues.push(tzParamValue);

                    delete repCrit.ParameterValuesWithText;

                    $('#main').showLoader();

                    $.ajax({
                        url: cafm.url.api('Report/PrintReport'),
                        type: 'POST',
                        contentType: 'application/json',
                        data: JSON.stringify({ Criteria: repCrit }),
                        processData: false,
                        xhrFields: {
                            responseType: 'blob' // to avoid binary data being mangled on charset conversion
                        },
                        success: function (r, m, req) {
                            var blob = new Blob([r], { type: r.type });
                            //View or download
                            var repiframe = document.createElement("iframe");
                            var downloadUrl = URL.createObjectURL(blob);
                            repiframe.setAttribute("src", downloadUrl);
                            repiframe.setAttribute("id", "reportViewerFrame");
                            window.open(downloadUrl, 'reportViewerFrame');
                        },
                        error: function (r, m, s) {
                            let errorMsg = unescape(r.getResponseHeader(cafm.res.consts.ResHeader_ErrorMessage))
                            $('#main').showMessage({
                                Title: errorMsg,
                                Type: cafm.enums.MessageType.Error
                            });
                            $('#main').hideLoader();
                        },
                        complete(r, m, s) {
                            $('#main').hideLoader();
                        },
                        statusCode: {
                            302(r, s, m) { // treat 302 as 401, as the only time an AJAX request will redirect is when the client is not authenticated.
                                cafm.auth.notAuthenticated(true);
                            },
                            401(r, s, m) {
                                cafm.auth.notAuthenticated(true);
                            }
                        }
                    });

                    break;

                case 'Cancel':
                    cafm.nav.router.navigate(cafm.enums.Navigatable.ReportsBrowse);
                    break;
            }
        }
    }
}